 
import { Ability } from '@casl/ability'

export const ability = new Ability()

export const abilityPlugin = (store) => {
    ability.update(store.state.user.current_user.permissions)

    return store.subscribe((mutation) => {
        switch (mutation.type) {
            case 'user/success':
                ability.update(mutation.payload.permissions)
            break
        }
    })
}

export const canNavigate = async (rules) => {
    let result = false
    await rules && Object.keys(rules).forEach(role => {
        rules[role].forEach(permission => {
            if(ability.can(permission, role)) {
                result = true
            }
        })
    })

    return result
}